import {
    storiesAbsoluteRoutes, storiesComplexAbsoluteRoutes,
    storiesComplexRelativeRoutes,
    storiesNamespaces,
    storiesRelativeRoutes
} from './defs/storiesNamespace';
import {searchAbsoluteRoutes, searchNamespaces, searchRelativeRoutes} from './defs/searchNamespace';
import {adminAbsoluteRoutes, adminNamespaces, adminRelativeRoutes} from './defs/adminNamespace';
import {settingsAbsoluteRoutes, settingsNamespaces, settingsRelativeRoutes} from './defs/settingsNamespace';
import {insightsAbsoluteRoutes, insightsNamespaces, insightsRelativeRoutes} from './defs/insightsNamespace';
import {customersAbsoluteRoutes, customersNamespaces, customersRelativeRoutes} from './defs/customersNamespace';
import {evaluationsAbsoluteRoutes, evaluationsNamespaces, evaluationsRelativeRoutes} from './defs/evaluationsNamespace';
import {emailReportsAbsoluteRoutes, emailReportsNamespaces, emailReportsRelativeRoutes} from './defs/emailreportsNamespace';
import {myemailReportsAbsoluteRoutes, myemailReportsNamespaces, myemailReportsRelativeRoutes} from './defs/myemailreportsNamespace';
import {dictionariesAbsoluteRoutes, dictionariesNamespaces, dictionariesRelativeRoutes} from './defs/dictionariesNamespace';


export const NAMESPACES = {
    ...adminNamespaces,
    ...customersNamespaces,
    ...evaluationsNamespaces,
    ...myemailReportsNamespaces,
    ...emailReportsNamespaces,
    ...dictionariesNamespaces,
    ...insightsNamespaces,
    ...searchNamespaces,
    ...settingsNamespaces,
    ...storiesNamespaces,
};

const simpleRelativeRoutes = {
    ...adminRelativeRoutes,
    ...customersRelativeRoutes,
    ...evaluationsRelativeRoutes,
    ...myemailReportsRelativeRoutes,
    ...emailReportsRelativeRoutes,
    ...dictionariesRelativeRoutes,
    ...insightsRelativeRoutes,
    ...searchRelativeRoutes,
    ...settingsRelativeRoutes,
    ...storiesRelativeRoutes,
};

export const RELATIVE_ROUTES = {
    ...simpleRelativeRoutes,

    ...storiesComplexRelativeRoutes,
};

const simpleAbsoluteRoutes = {
    ...adminAbsoluteRoutes,
    ...customersAbsoluteRoutes,
    ...evaluationsAbsoluteRoutes,
    ...myemailReportsAbsoluteRoutes,
    ...emailReportsAbsoluteRoutes,
    ...dictionariesAbsoluteRoutes,
    ...insightsAbsoluteRoutes,
    ...searchAbsoluteRoutes,
    ...settingsAbsoluteRoutes,
    ...storiesAbsoluteRoutes,
};


export const ABSOLUTE_ROUTES = {
    ...simpleAbsoluteRoutes,

    ...storiesComplexAbsoluteRoutes,
};

// Simple routes are 1:1 key:value pairs whereas the rest can also be 1:n key:[value,value,value] pairs
const _simpleRoutes = {
    ...NAMESPACES,
    ...simpleRelativeRoutes,
    ...simpleAbsoluteRoutes,
} as const;
export type SimpleRouteKeys = keyof typeof _simpleRoutes;
export type SimpleRoutes = typeof _simpleRoutes;
export const SIMPLE_ROUTES = <SimpleRoutes>_simpleRoutes;

const _routes = {
    ...NAMESPACES,

    ...RELATIVE_ROUTES,

    ...ABSOLUTE_ROUTES,
} as const;


const _routeStringValues = Object.values(_routes).flat();

export type RouteKeys = keyof typeof _routes;
export type RouteValues = typeof _routes[RouteKeys];
export type RouteStringValues = typeof _routeStringValues[number];

export type Routes = typeof _routes;

export const ROUTES = <Routes>_routes;
